import Alpine from 'alpinejs'
import barba from '@barba/core';
import barbaCss from '@barba/css';
import barbaPrefetch from '@barba/prefetch';
import Swiper from 'swiper';
import Macy from 'macy';
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks.js';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;

window.Alpine = Alpine
Alpine.start();


function initSwiper() {
    const swiper = new Swiper ('.js-project-slider', {
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: {
            loadPrevNext: true,
        },
        watchOverflow: true,
        watchSlidesVisibility: true,
        loop: true,
        autoplay: false,
        slidesPerView: 1,
        spaceBetween: 0,

        navigation: {
            nextEl: '.swiper-button-next',
        },

        pagination: {
            el: '.swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
                return current + '/' + total;
            }
        },
        on: {
            init: function() {
                if(this.slides.length == 3){
                    this.allowTouchMove = false;
                    this.el.querySelector('.swiper-button-next').style.display = "none";
			        this.params.pagination = false;
                }
                this.navigation.init();
            },
            click: function() {
                if(this.slides.length !== 3){
                    this.slideNext();
                }
            },
        }
    })
}

barba.use(barbaCss);
barba.use(barbaPrefetch);

barba.hooks.enter(() => {});

if(!window.contactForm){
  window.contactForm = function () {
      return {
        formData: {
          name: '',
          email: '',
          description: '',
          _token: document.querySelector('input[name="_token"]').value,
        },
        message: '',
        loading: false,
        success_message: false,
        buttonLabel: 'Enquire',
  
        submitData() {
          this.buttonLabel = 'Submitting...'
          this.loading = true;
          this.message = ''
  
          fetch('/!/forms/enquiry', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(this.formData),
            })
              .then(() => {
                this.message = 'Form sucessfully submitted!'
              })
              .catch(() => {
                this.message = 'Ooops! Something went wrong!'
              })
              .finally(() => {
                this.loading = false;
                this.buttonLabel = 'Thank You'
                this.success_message = true
              })
  
        }
      }
    }
}

if(!window.subscribeForm){
  window.subscribeForm = function () {
      return {
          formData: {
            fname: '',
            lname: '',
            email: '',
            _token: document.querySelector('input[name="_token"]').value,
          },
          message: '',
          loading: false,
          success_message: false,
          error_message: '',
          buttonLabel: 'Subscribe',
    
          submitData() {
            this.buttonLabel = 'Submitting...'
            this.loading = true;
            this.message = '';
            this.error_message = '';
    
            fetch('/subscribe/submit', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(this.formData),
              })
                .then(function(response) {
                    if (response.status >= 400 && response.status < 600) {
                        return response.json().then(json => { throw json; });
                    }
                    return response.json();
                })
                .then(() => {
                  this.message = 'Form sucessfully submitted!';
                  //console.log('Success:', res.json());
                  this.buttonLabel = 'Success';
                  this.success_message = true;
                })
                .catch((err) => {
                  console.log(err);
                  this.error_message = err.errorMsg;
                  this.buttonLabel = 'Subscribe';
                  this.message = 'Ooops! Something went wrong!';
                })
                .finally(() => {
                  this.loading = false;
                })
    
          }
        }
    }
}

var cultureHeight = 0;

barba.init({
    timeout: 50000, // default is 2000ms
    transitions: [
        {
            name: 'home',
            once() {},
            leave() {},
            enter() {},
        }
    ],
    views: [
        {
        namespace: 'home',
        beforeEnter() {
            // scroll to our previously set height
            console.log(cultureHeight);
            window.scrollTo({top: cultureHeight});
            initSwiper();

            lazySizes.init();

            var macy = Macy({
                container: '.js-masonry',
                trueOrder: false,
                waitForImages: false,
                margin: 48,
                columns: 3,
                breakAt: {
                    1024: 2,
                    640: 1
                }
            });

            // macy.runOnImageLoad(function () {
            //     macy.recalculate(true);
            // }, true);

            // document.addEventListener('lazybeforeunveil', function(e){
            //     macy.recalculate(true);
            // });

        },
        afterEnter() {},
        beforeLeave() {
            // set height on leave
            cultureHeight = window.scrollY;

        },
      },
      {
      namespace: 'tags',
        beforeEnter() {
            window.scrollTo({top: 0});

            lazySizes.init();

            var macy = Macy({
                container: '.js-masonry',
                trueOrder: false,
                waitForImages: false,
                margin: 48,
                columns: 3,
                breakAt: {
                    1024: 2,
                    640: 1
                }
            });

            macy.runOnImageLoad(function () {
                macy.recalculate(true);
            }, true);

            document.addEventListener('lazybeforeunveil', function(e){
                macy.recalculate(true);
            });

        },
        afterEnter() {}
      },
      {
      namespace: 'project',
        beforeEnter() { 

            window.scrollTo({top: 0});

            initSwiper();

              var macy = Macy({
                  container: '.js-masonry',
                  trueOrder: false,
                  waitForImages: false,
                  margin: 48,
                  columns:2,
                  breakAt: {
                      768: 2,
                      640: 1
                  }
              });

              macy.runOnImageLoad(function () {
                macy.recalculate(true, true);
                window.dispatchEvent(new Event('resize', {}));
              }, true);

        },
        afterEnter() {

        }
      },
      {
        namespace: 'page',
        beforeEnter(data) {
            //window.scrollTo({top: 0});
            initSwiper();

        },
        afterEnter() {
            
        }
      },
    ]
});
